import {qiniuResource as qr} from '../libs/common_funcs'
import { resourceServer } from '../config/common'

export const qiniuResource = value => {
    return qr(value)
}

//视频第一帧
export const videoImgUrl = (src, w, h) => {
    if (!src) {
        return ''
    }
    if (src.indexOf('http') != -1 || src.indexOf('/static') != -1) {
        return src
    }
    let urls = resourceServer +'/'+ src + `?vframe/jpg/offset/1/w/${w || 360}/h/${h || 360}`
    return urls
};


// WEBPACK FOOTER //
// ./src/filters/qiniu_resource.js